import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { BLOG_ACTION_TYPE } from "./blog.action";
import { BlogState } from "./blog.model";

const INITIAL_STATE: BlogState = {};

export function blogReducer(state = INITIAL_STATE, action: ActionWithPayload): BlogState {
	switch (action.type) {
		case BLOG_ACTION_TYPE.getFeedSuccess:
			return updateState(state, {
				posts: action.payload,
			});
		case BLOG_ACTION_TYPE.getFeedFail:
			return updateState(state, {
				posts: undefined,
			});
	}
	return state;
}
